import { StartingPageEffects } from './starting-page.effect';
import { SetDashboardEffects } from './set-dashboard.effect';

export const effects = [StartingPageEffects, SetDashboardEffects];

export * from './starting-page.effect';
export * from './set-dashboard.effect';
